import { StatusIndicatorRoot } from "../../../../../ui/status-indicator/root.js";
import { StatusIndicatorValue } from "../../../../../ui/status-indicator/value.js";
import ForwardRef from "../../../../../icons/dist/react/default/captions-off.js";
import ForwardRef$1 from "../../../../../icons/dist/react/default/captions-on.js";
import ForwardRef$2 from "../../../../../icons/dist/react/default/fullscreen-enter.js";
import ForwardRef$3 from "../../../../../icons/dist/react/default/fullscreen-exit.js";
import ForwardRef$4 from "../../../../../icons/dist/react/default/pause.js";
import ForwardRef$5 from "../../../../../icons/dist/react/default/pip-enter.js";
import ForwardRef$6 from "../../../../../icons/dist/react/default/pip-exit.js";
import ForwardRef$7 from "../../../../../icons/dist/react/default/play.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/default-video/components/feedback/status-indicator.tsx
/** @jsxImportSource react */
const TOP_STATUS_ACTIONS = [
	"toggleSubtitles",
	"toggleFullscreen",
	"togglePictureInPicture"
];
const PLAYBACK_STATUS_ACTIONS = ["togglePaused"];
function StatusIndicator({ className, ...props } = {}) {
	return /* @__PURE__ */ jsx(StatusIndicatorRoot, {
		actions: TOP_STATUS_ACTIONS,
		className: (state) => cn("media-indicator", "media-status-indicator", resolveClassName(className, state)),
		...props,
		children: /* @__PURE__ */ jsxs("div", {
			className: cn("media-indicator-content", "media-status-indicator-content"),
			children: [
				/* @__PURE__ */ jsx(ForwardRef$1, { className: "media-status-indicator-captions-on-icon" }),
				/* @__PURE__ */ jsx(ForwardRef, { className: "media-status-indicator-captions-off-icon" }),
				/* @__PURE__ */ jsx(ForwardRef$2, { className: "media-status-indicator-fullscreen-enter-icon" }),
				/* @__PURE__ */ jsx(ForwardRef$3, { className: "media-status-indicator-fullscreen-exit-icon" }),
				/* @__PURE__ */ jsx(ForwardRef$5, { className: "media-status-indicator-pip-enter-icon" }),
				/* @__PURE__ */ jsx(ForwardRef$6, { className: "media-status-indicator-pip-exit-icon" }),
				/* @__PURE__ */ jsx(StatusIndicatorValue, { className: "media-status-indicator-value" })
			]
		})
	});
}
function PlaybackStatusIndicator({ className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(StatusIndicatorRoot, {
		actions: PLAYBACK_STATUS_ACTIONS,
		className: (state) => cn("media-playback-status-indicator", resolveClassName(className, state)),
		...props,
		children: [/* @__PURE__ */ jsx(ForwardRef$7, { className: "media-playback-status-indicator-play-icon" }), /* @__PURE__ */ jsx(ForwardRef$4, { className: "media-playback-status-indicator-pause-icon" })]
	});
}
//#endregion
export { PlaybackStatusIndicator, StatusIndicator };

//# sourceMappingURL=status-indicator.js.map